import { getDishByPhaseStep } from '../../shared/utils/phase';

// vrací data vybraných produktů (id produktu, jeho počet a pod kterou fází a ve kterém kroku byl vybrán) ve formátu pro BE
export const getOrdersProductData = (isDietModeAndLastPhase, savedProducts, phaseId) => {
    const pickedProducts = [];

    if (!savedProducts) {
        return [];
    }

    if (isDietModeAndLastPhase) {
        Object.keys(savedProducts).forEach((phaseIdKey) =>
            Object.keys(savedProducts[phaseIdKey]).forEach((phaseStepKey) =>
                savedProducts[phaseIdKey][phaseStepKey].forEach((product) =>
                    pickedProducts.push({
                        productId: product.id,
                        amount: product.amount,
                        phaseId: phaseIdKey,
                        dish: getDishByPhaseStep(phaseStepKey),
                    })
                )
            )
        );
    } else {
        Object.keys(savedProducts[phaseId]).forEach((phaseStepKey) =>
            savedProducts[phaseId][phaseStepKey].forEach((product) =>
                pickedProducts.push({
                    productId: product.id,
                    amount: product.amount,
                    phaseId: phaseId,
                    dish: getDishByPhaseStep(phaseStepKey),
                })
            )
        );
    }

    return pickedProducts.filter((product) => product.amount > 0);
};
